import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MapHelperService } from 'src/services/map-helper.service';
import { TurfHelperService } from 'src/services/turf-helper.service';
import { EnumBufferTypes } from '../../../../shared/helpers/enums/EnumBufferTypes';
import { EnumFeaturesActionsDestinations } from '../../../../shared/helpers/enums/EnumFeaturesActionsDestinations';
import { point } from '@turf/helpers';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { environment } from "src/environments/environment";
import { MAP_MODULE_NAMES } from 'src/models/common/EnumMapas';
import { SessionService } from 'src/app/features/shared/services/Session.service';
import { EncriptionService } from 'src/app/features/shared/services/Encription.service';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';
import { PolygonDrawToolService } from 'src/services/maps/features/PolygonDrawTool.service';

@Injectable({
  providedIn: "root",
})
export class GeofencesMapService {
  
  //para buffer
  bufferCenterLat: number = 0;
  bufferCenterLng: number = 0;
  bufferRadioKm: number = 0.5;
  public bufferFeature: any = null;
  
  constructor(
    private mapHelperService: MapHelperService, private turfHelperService: TurfHelperService, private sessionService:  SessionService,
    private polygonDrawToolService: PolygonDrawToolService,
    private localStorageService:  LocalStorageService, 
    private encriptionService:  EncriptionService
    ) {
  }

  LoadMapGeofences() {
    // this.mapIntentService._map.on("load", () => {
      // const current = this.sessionService.loadedMapComponents.value;
      // this.sessionService.loadedMapComponents.next([...current, MAP_MODULE_NAMES.Geofences]);
      this.addViewAsLoadedToStorage();
      this.initializeMapGeofences();
    
    // });
  }

    
  initializeMapGeofences() {
    //sources para geocercas
    this.mapHelperService.AddSourceEmptyGeoJson("recurrentPlacesSource", "Lugares recurrentes", 'annotation-cloropet-polygon-selector.png');
    this.mapHelperService.AddSourceEmptyGeoJson("bufferActiveSource", "Buffer activo", 'annotation-buffer.png');
    this.mapHelperService.AddSourceEmptyGeoJson("PolygonActiveSource", "Polígono activo", 'annotation-polygon.png');
    this.mapHelperService.AddSourceEmptyGeoJson("geofencesSource", "Geocercas", 'annotation-geofence-polygon.png');
    this.mapHelperService.AddSourceHighEmptyGeoJson("Geocercas-highSource", "Icono de geocercas", 'geofence.png');
    this.mapHelperService.AddBaseMapSatellite();
    
    this.mapHelperService.AddLayerBufferRecurrent("layer-recurrentPlaces","recurrentPlacesSource", EnumBufferTypes.Default, "Lugares recurrentes");
    this.mapHelperService.AddLayerBufferActive("layer-bufferActive", "bufferActiveSource", EnumBufferTypes.Default, "Buffer activo");
    this.mapHelperService.AddLayerGeofencesPolygons( "layer-polygonActive", "PolygonActiveSource", "Polígono activo");
    
    this.mapHelperService.AddLayerText("layer-recurrentPlacesText", "recurrentPlacesSource", "Name", "Etiqueta de lugares recurrentes", -4);
    this.mapHelperService.ShowHideLayer("satellite-layer");
    this.mapHelperService.ShowHideLayer("satellite-layer");
  }
    
      // --------- buffer -------------------- 
  UpdateActiveBuffer(lat: number, lng: number, radioKm: number) {
    if(!environment.production) console.log("[UPDATE ACTIVE BUFFER] - BUFFER", lat, lng, radioKm);
    
    this.bufferCenterLat = lat;
    this.bufferCenterLng = lng;

    this.mapHelperService.UpdateActivePoint(this.bufferCenterLat, this.bufferCenterLng, "bufferPointActiveSource");
    this.bufferFeature = this.turfHelperService.getBufferGeoJSON(lat, lng, radioKm);
    this.mapHelperService.FitBounds(this.bufferFeature.geometry);
    this.mapHelperService.UpdateLayerGeoJson("bufferActiveSource", this.bufferFeature);
    var pointsLayer = this.mapHelperService._map.getSource("pointsSource");
    if (!pointsLayer) {
      if(!environment.production) console.log("No existe la capa pointsSource");
      return;
    }
    var points = pointsLayer._data;
    var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon( points, this.bufferFeature  );
    var features = turfFeaturesInsideArea.features;
    if(!environment.production) console.log("features", features);
    
    //TODO atomizar
    var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Geofences };
    this.mapHelperService.featuresInsideArea.next(featuresResult);

    return this.bufferFeature;
  }
 
  ResetActiveBuffer() {
    this.mapHelperService.UpdateActivePoint(this.bufferCenterLat, this.bufferCenterLng, "bufferPointActiveSource");
    this.mapHelperService.UpdateLayerGeoJson("bufferActiveSource", this.mapHelperService.Empty_GeoJson);
  }

  bufferClickHandler = (e) => {
    this.bufferCenterLat = e.lngLat.lat;
    this.bufferCenterLng = e.lngLat.lng;

    var buffer = this.UpdateActiveBuffer(this.bufferCenterLat, this.bufferCenterLng, this.bufferRadioKm);
    // this.panelAddGeofencesService.setVisibleControlSliderRadio(true);
    
    this.polygonDrawToolService.addGeofenceBufferDrawControl();
    this.polygonDrawToolService.drawGeofenceBuffer.add(buffer);
    if (this.mapHelperService._map)
      this.mapHelperService._map.off("click", this.bufferClickHandler);
  };

  addBufferDrawControl(){
    this.removeBufferDrawControl();
    this.mapHelperService._map.on("click", this.bufferClickHandler);
  }

  removeBufferDrawControl(){
    this.mapHelperService._map.off("click", this.bufferClickHandler);
  }

  addViewAsLoadedToStorage(){
    const mapLoadedViewsEnc = this.localStorageService.getMapLoadedViews();
    if (mapLoadedViewsEnc == null) {
      return;
    }
    
    const decrypted = this.encriptionService.DecryptData(mapLoadedViewsEnc);
    if (decrypted == null) {
      this.localStorageService.setMapLoadedViews(this.encriptionService.EncryptData(JSON.stringify([MAP_MODULE_NAMES.Geofences])) );
      this.sessionService.loadedMapComponents.next([MAP_MODULE_NAMES.Geofences]);
      return;
    }
    
    var arr: any[] = [];
    try {
      const parsed = JSON.parse(decrypted);
      arr = parsed;
    } catch (e) {
      arr = [];
    }
    
    const key = MAP_MODULE_NAMES.Geofences;
    if (!arr.includes(key)) {
      arr.push(key);
      this.localStorageService.setMapLoadedViews(this.encriptionService.EncryptData(JSON.stringify(arr)) );
      this.sessionService.loadedMapComponents.next(arr);
    }
  }
 
}
